/*
 * Planigo
 * Auteur  : Stéphane Raverdy
 * Société : SCIAD 2026
 */
import React from 'react';
import { reportClientError } from '../lib/api';

// REGLE DE GESTION : une erreur React ne doit jamais laisser un ecran blanc.
export default class AppErrorBoundary extends React.Component {
  constructor(props){super(props);this.state={error:null};}
  componentDidCatch(error, info){console.error('Planigo React render error', error, info);reportClientError({page:window.location.pathname,action:'Erreur rendu React',error_name:error?.name,message:error?.message||String(error),stack:error?.stack,component_stack:info?.componentStack,...(window.__PROJETHUB_LAST_API_ERROR__||{})});this.setState({error});}
  render(){
    if(!this.state.error) return this.props.children;
    return <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'#f8fafc',padding:24,fontFamily:'sans-serif'}}><div style={{maxWidth:560,width:'100%',background:'#fff',border:'1px solid #e2e8f0',borderRadius:16,padding:24}}><h2>Planigo a rencontré une erreur d’affichage</h2><p>L’erreur a été envoyée automatiquement dans Administration &gt; Logs de traitement. Vous pouvez recharger la page.</p><button onClick={()=>window.location.reload()} style={{border:0,borderRadius:10,padding:'10px 16px',background:'#2563eb',color:'#fff',fontWeight:700,cursor:'pointer'}}>Recharger la page</button></div></div>;
  }
}
